import { lazy } from 'react'

const TermsOfService = lazy(
  () => import(/* webpackChunkName: "TermsOfService" */ './TermsOfService'),
)
export default TermsOfService
